var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.34005 2.92999L2.93005 4.33999L7.29005 8.69999L7.00005 8.99999H3.00005V15H7.00005L12.0001 20V13.41L16.1801 17.59C15.5301 18.08 14.8001 18.47 14.0001 18.7V20.76C15.3401 20.46 16.5701 19.84 17.6101 19.01L19.6601 21.06L21.0701 19.65L4.34005 2.92999ZM10.0001 15.17L7.83005 13H5.00005V11H7.83005L8.71005 10.12L10.0001 11.41V15.17ZM19.0001 12C19.0001 12.82 18.8501 13.61 18.5901 14.34L20.1201 15.87C20.6801 14.7 21.0001 13.39 21.0001 12C21.0001 7.71999 18.0101 4.13999 14.0001 3.22999V5.28999C16.8901 6.14999 19.0001 8.82999 19.0001 12ZM12.0001 3.99999L10.1201 5.87999L12.0001 7.75999V3.99999ZM16.5001 12C16.5001 10.23 15.4801 8.70999 14.0001 7.96999V9.75999L16.4801 12.24C16.4901 12.16 16.5001 12.08 16.5001 12Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOff);
export default __webpack_public_path__ + "static/media/volume_off.8b23ccc49a62af1b750c0d87b4448b33.svg";
export { ForwardRef as ReactComponent };